import React from "react";
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogTrigger,
  Button,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { reorderDialogStyles } from "./ReorderDialogStyles";

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string | JSX.Element;
  dialogButton?: string;
  dialogAction: () => void;
  cancelButton?: string;
  dismissAction?: () => void;
}

export const ReusableDialog: React.FC<DialogProps> = ({
  isOpen,
  onClose,
  title,
  message,
  dialogButton,
  dialogAction,
  cancelButton = "Cancel",
  dismissAction,
}) => {
  const styles = reorderDialogStyles();
  return (
    <Dialog modalType="modal" open={isOpen} onOpenChange={(event, data) => data.open || onClose()}>
      <DialogSurface className={styles.dialogContainer}>
        <div className={styles.dialogTitleContainer}>
          <DialogTitle
            className={styles.dialogTitle}
            action={
              <DialogTrigger action="close">
                <Button
                  appearance="subtle"
                  aria-label="close"
                  icon={<Dismiss24Regular />}
                  onClick={onClose}
                  tabIndex={0}
                />
              </DialogTrigger>
            }
          >
            {title}
          </DialogTitle>
        </div>
        <DialogContent className={styles.dialogBody}>
          {typeof message === "string" ? (
            <div style={{ whiteSpace: "pre-line" }}>{message}</div>
          ) : (
            message
          )}
        </DialogContent>
        <DialogActions className={styles.dialogButton}>
          {dismissAction && (
            <Button appearance="secondary" onClick={dismissAction} className={styles.cancelButton}>
              {cancelButton}
            </Button>
          )}
          <Button className={styles.continueButton} appearance="primary" onClick={dialogAction}>
            {dialogButton}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
};
